<script setup>
  import { ref, computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import WidgetPreview from '@/components/WidgetPreview.vue';
  import WidgetEmbedFrame from '@/components/WidgetEmbedFrame.vue';
  import { useWidgetStore } from '@/stores/WidgetStore';

  const widgetStore = useWidgetStore();

  const { t } = useI18n();

  const scale = ref(1);

  const widgetId = computed(() => widgetStore.activeWidgetId);
  const embed = computed(() => widgetStore.embeds[widgetId.value]);

  const sizeLabel = computed(() => {
    const size = { width: embed.value.width, height: embed.value.height };
    const percent = Math.round(scale.value * 100);

    return percent < 100 ? t('widgets.previewSizeScaled', { ...size, percent }) : t('widgets.previewSize', size);
  });

  const stageStyles = computed(() => ({
    '--jwx-widget-editor-preview-width': `${embed.value.width}px`,
    '--jwx-widget-editor-preview-ratio': `${embed.value.width} / ${embed.value.height}`
  }));
</script>

<template>
  <section class="jwx-widget-editor__preview jwx-widget-editor-preview" :aria-label="t('widgets.editorPreview')">
    <p class="jwx-chip jwx-widget-editor-preview__size" data-selected="true">
      <span class="jwx-chip__text">{{ sizeLabel }}</span>
    </p>

    <div class="jwx-widget-editor-preview__stage" :style="stageStyles">
      <WidgetPreview v-model:scale="scale" :width="embed.width" :height="embed.height">
        <!-- Keyed by widget, so switching widgets loads a fresh frame -->
        <WidgetEmbedFrame :key="widgetId" :widgetId="widgetId" interactive />
      </WidgetPreview>
    </div>
  </section>
</template>
